import React from 'react';

import { NavigationItemComponentFragment } from '../../../graphql.schema';
import { NavigationDropdown } from '../NavigationDropdown/NavigationDropdown';
import { NavigationLink } from '../NavigationLink/NavigationLink';

type NavigationItemProps = {
  item: NavigationItemComponentFragment;
  className?: string;
};

export const NavigationItem = ({ item, className }: NavigationItemProps) => {
  if (item.childLinks?.length) {
    return <NavigationDropdown className={className} item={item} />;
  }
  if (item.link) {
    return <NavigationLink className={className} link={item.link} />;
  }
  return null;
};
